import { Group, Stack } from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { Button, EqualWidthGrid } from "@tfg/ui"

import { TypesFormProps } from "~/pages/Admin/components/TypesForm"

type TypesFormActionsSectionProps<T extends Record<string, unknown>> = Pick<
  TypesFormProps<T>,
  | "closeDrawer"
  | "cancelLabel"
  | "submitLabel"
  | "readonly"
  | "footerVariant"
  | "deleteLabel"
  | "handleDelete"
  | "isLoading"
  | "showCancel"
> & {
  form: UseFormReturnType<T>
}

export const TypesFormActionsSection = <T extends Record<string, unknown>>({
  form,
  closeDrawer,
  cancelLabel,
  submitLabel,
  readonly = false,
  footerVariant = "default",
  deleteLabel,
  handleDelete,
  isLoading = false,
  showCancel = true,
}: TypesFormActionsSectionProps<T>) => {
  if (readonly) {
    return null
  }

  if (footerVariant === "pinned") {
    const shouldShowCancel = showCancel && closeDrawer !== undefined

    return (
      <Group
        justify="space-between"
        align="center"
        wrap="nowrap"
        gap="xs"
        pt="md"
        style={{
          flexShrink: 0,
          borderTop: "1px solid var(--mantine-color-gray-1)",
        }}
      >
        {deleteLabel && handleDelete ? (
          <Button variant="tertiary-critical" onClick={handleDelete}>
            {deleteLabel}
          </Button>
        ) : null}
        <Group
          gap="xs"
          wrap="nowrap"
          justify="flex-end"
          style={{ flex: 1, minWidth: 0 }}
        >
          {shouldShowCancel ? (
            <Button variant="tertiary" onClick={closeDrawer}>
              {cancelLabel}
            </Button>
          ) : null}
          <Button type="submit" loading={isLoading}>
            {submitLabel}
          </Button>
        </Group>
      </Group>
    )
  }

  return (
    <Stack py="md" pos="sticky" bg="white" bottom={0} left={0} right={0}>
      <EqualWidthGrid>
        <Button size="sm" variant="tertiary" onClick={closeDrawer} fullWidth>
          {cancelLabel}
        </Button>
        <Button size="sm" disabled={!form.isValid()} type="submit" fullWidth>
          {submitLabel}
        </Button>
      </EqualWidthGrid>
    </Stack>
  )
}
